/* Written by Ye Liu */

import React from 'react';
import M from 'materialize-css';
import Slide from '@material-ui/core/Slide';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Typography, Icon, IconButton } from '@material-ui/core';
  
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import indigo from '@material-ui/core/colors/indigo';

import emitter from '@utils/events.utils';
import { ACCESS_TOKEN } from '@/config';

import '@styles/dataController.style.css';
import ControlledAccordions from '@components/componentsJS/ControlledAccordions___';

const theme = createTheme({
    palette: {
        primary: {
            main: indigo.A200
        }
    }
});

const styles = {
    root: {
        position: 'fixed',
        top: 74,
        right: 10,
        borderRadius: 9,
        minWidth: 350,
        margin: 0,
        zIndex: 900,
        boxShadow: '-6px 6px 15px rgba(0, 0, 0, 0.15)',
    },
    rooot: {
        width: '100%',
      },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
      },
      secondaryHeading: {
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
      },
    header: {
        backgroundColor: 'rgba(142,36,170,255)'
    },
    closeBtn: {
        position: 'absolute',
        top: 6,
        right: 8,
        fontSize: 22
    },
    searchField: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        height: 40,
        padding: '2px 4px'
    },
    searchBox: {
        marginLeft: 8,
        flex: 1,
        border: 'none !important'
    },
    searchBoxBtn: {
        padding: 8
    },
    searchOptionsContainer: {
        padding: '5px 2px'
    },
    searchOption: {
        color: 'rgba(0, 0, 0, 0.6)',
        cursor: 'pointer'
    },
    searchBoxProgress: {
        marginRight: 8
    },
    searchBoxDivider: {
        width: 1,
        height: 28,
        margin: 4
    },
    resultWrapperOpen: {
        maxWidth: 800
    },
    resultWrapperClosed: {
        maxWidth: 350
    },
    resultContainer: {
        paddingTop: 0,
        paddingBottom: 0
    },
    resultTable: {
        boxShadow: 'none'
    },
    content: {
        paddingBottom: 16
    },
    uploadBoxInput: {
        display: 'none'
    },
    uploadBoxBtnEdit: {
        width: 40,
        height: 40,
        lineHeight: '40px',
        textAlign: 'center',
        borderRadius: '50%',
        fontSize: 22
    },
    wrapBtn: {
        position: 'absolute',
        bottom: 12,
        left: 18,
        padding: 10,
        fontSize: 24
    },
    addPointWrapperOpen: {
        maxWidth: 350
    },
    addPointWrapperClose: {
        width: 0
    },
    uploadBoxBtnAdd: {
        width: 90,
        height: 90,
        lineHeight: '90px',
        textAlign: 'center',
        borderRadius: '50%',
        fontSize: 30,
        backgroundColor: 'rgba(0, 0, 0, 0.08)'
    },
    previewImageContainer: {
        display: 'flex',
        alignItems: 'center'
    },
    nameTextField: {
        margin: '0 20px 0 13px'
    },
    pinyinTextField: {
        margin: '10px 20px 10px 13px'
    },
    introTextField: {
        width: '100%',
        marginTop: 5
    },
    locationImageContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    locationImage: {
        display: 'block',
        marginTop: 5,
        width: 225,
        height: 140,
        borderRadius: 3,
        cursor: 'pointer'
    },
    locationLabel: {
        display: 'block',
        marginTop: 6
    },
    actions: {
        paddingTop: 10
    },
    saveBtn: {
        display: 'inline-block',
        position: 'relative',
        marginRight: 10
    },
    saveBtnProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    }
};

class SocController extends React.Component {
    state = {
        open: false,
        resultUnwrap: false,
        addPointUnwrap: false,
        optionsOpen: false,
        searching: false,
        submitting: false,
        anchorEl: null,
        geometry: null,
        previewImage: null,
        previewMapUrl: null,
        previewCoordinate: {},
        loading: true
    }

    handleDecision = (choice) => {
        this.setState({ decision: choice });
      };    

    initMaterialbox = () => {
        var elems = document.querySelectorAll('.materialboxed');
        M.Materialbox.init(elems, {
            onOpenStart: (e) => {
                e.parentNode.style.overflow = 'visible';
            },
            onCloseEnd: (e) => {
                e.parentNode.style.overflow = 'hidden';
            }
        });
    }
    
    resetPreviewImage = () => {
        this.setState({
            previewImage: null
        });
    }

    resetNewPointData = () => {
        this.setState({
            previewMapUrl: null,
            geometry: null,
            previewCoordinate: {}
        });
    }

    handleCloseClick = () => {
        this.setState({
            open: false
        });
    }

    handleDataSubmit = (output, metrics) => {
        // Si hay advertencia del backend, mostrarla como warning
        if (output && output.warning) {
            emitter.emit('showSnackbar', 'warning', output.warning);
            return;
        }
        // Validación de GeoJSON antes de emitir 'moveURL'
        let resultArray = Array.isArray(output) ? output : (output && Array.isArray(output.output) ? output.output : null);
        if (resultArray) {
            // Validar que output[3] (o el índice correspondiente) sea un GeoJSON Polygon válido
            const polygon = resultArray[3];
            if (!polygon || typeof polygon !== 'object' || polygon.type !== 'Polygon' || !Array.isArray(polygon.coordinates)) {
                emitter.emit('showSnackbar', 'error', 'El resultado no contiene un polígono GeoJSON válido para mostrar en el mapa.');
                return;
            }
            // Construir el objeto de capa correctamente para LayerController
            const newLayer = {
                id: resultArray[2] || 'SOC',
                visible: true,
                transparency: 100,
                min: (resultArray[1] && resultArray[1].min != null ? resultArray[1].min : (resultArray[4] != null ? resultArray[4] : 0)),
                max: (resultArray[1] && resultArray[1].max != null ? resultArray[1].max : (resultArray[5] != null ? resultArray[5] : 6)),
                dataset: resultArray[6],
                startDate: resultArray[7],
                endDate: resultArray[8],
                metrics: metrics
            };
            emitter.emit('newLayer', newLayer);
            this.setState({url: output});
            console.log("Datos recibidos en ModelController (array):", output);
            emitter.emit('moveURL', output);
        } else {
            console.error('El resultado recibido no es un array válido:', output);
            emitter.emit('showSnackbar', 'error', 'El resultado recibido no es válido para mostrar en el mapa.');
        }
    };

    handleAddClick = () => {
        // Get GeoJSON from map
        emitter.emit('getPoint');

        // Exit search mode
        this.handleWrapClick();

        // Initialize new point data
        this.resetPreviewImage();
        this.resetNewPointData();

        // Wrap add point panel
        this.setState({
            addPointUnwrap: false
        });
    }

    handleWrapClick = () => {
        // Remove temp layer
        emitter.emit('removeTempLayer');

        // Reset preview image
        this.resetPreviewImage();

        // Clear search box
        document.getElementById('search-box').value = '';

        this.setState({
            resultUnwrap: false
        });
    }

    handleImageChange = (e) => {
        // Check if file selected
        if (!e.target.files[0]) {
            return;
        }

        // Check image size (smaller than 1MB)
        if (e.target.files[0].size > 1048576) {
            emitter.emit('showSnackbar', 'error', 'Error: Image must be smaller than 1MB.');
            return;
        }

        // Encode image with base64
        this.state.reader.readAsDataURL(e.target.files[0]);
    }

    handleDoneEdit = () => {
        // Reset preview image
        this.resetPreviewImage();

        // Initialize Materialbox
        setTimeout(this.initMaterialbox, 800);
    }

    handleSearchOptionsClick = () => {
        this.setState({
            optionsOpen: true
        });
    }

    handleSearchOptionsClose = () => {
        this.setState({
            optionsOpen: false
        });
    }

    
    handleSearchOptionChange = (e) => {
        // Update search options
        var option = null;
        var flag = false;
        this.state.searchOptions.map(item => {
            if (item.value === e.currentTarget.value) {
                item.checked = e.currentTarget.checked;
                option = item;
            }
            flag = flag || item.checked;
            return true;
        });

        // Check whether at least one option checked
        if (!flag) {
            emitter.emit('showSnackbar', 'error', 'Error: Please select at least one option.');
            option.checked = true;
            return;
        }

        this.setState({
            searchOptions: this.state.searchOptions
        });
    }

    handleSearchClick = () => {
        // Exit add point mode
        this.handleCancelClick();

        // Get keyword
        var keyword = document.getElementById('search-box').value;
        if (!keyword) {
            return;
        }

        // Show searching progress
        this.setState({
            searching: true
        });

        // Get search options
        var options = {};
        this.state.searchOptions.map(item => {
            options[item.value] = item.checked;
            return true;
        });
    }

    handlePreviewClick = (e, data) => {
        // Show marker and popup on map
        emitter.emit('displayTempLayer', data);
    }

    handlePreviewMapClick = () => {
        // Get GeoJSON from map
        emitter.emit('getPoint');

        this.setState({
            addPointUnwrap: false
        });
    }

    handleSelectChange = (event) => {
        this.setState({ [event.target.name]: Number(event.target.value) });
    };

    calculateSustainabilityIndex = () => {
        const { Ic, Ih, Ig, Io, If, IoType } = this.state;
        let IoValue = Io === 1 ? IoType : 0;
        const index = 2.45 * Ic + 2.18 * Ih + 1.64 * Ig + 1.09 * IoValue + 1 * If;
        this.setState({ sustainabilityIndex: index });
    };

    handleSubmitClick = () => {
        // Remove temp point
        emitter.emit('removeTempPoint');

        // Show button progress
        this.setState({
            submitting: true
        });


        // Initiate request
    }

    handleCancelClick = () => {
        // Remove temp point
        emitter.emit('removeTempPoint');

        // Empty input box
        document.getElementById('name').value = '';
        document.getElementById('pinyin').value = '';
        document.getElementById('introduction').value = '';

        // Reset data
        this.resetPreviewImage();
        this.resetNewPointData();

        // Wrap add point panel
        this.setState({
            addPointUnwrap: false
        });
    }

    componentDidMount() {
        // Initialize popover
        var anchorEl = document.getElementById('anchorEl');

        // Initialize file reader
        var reader = new FileReader();
        reader.onload = (e) => {
            // Get image info
            var image = new Image();
            image.src = e.target.result;

            // Construct preview image object
            var previewImage = {
                longitude: image.height > image.width,
                src: e.target.result
            }

            // Preview image
            this.setState({
                previewImage: previewImage
            });
        };

        this.setState({
            reader: reader,
            anchorEl: anchorEl
        });

        // Bind event listeners
        this.openSocControllerListener = emitter.addListener('openSocController', () => {
            this.setState({
                open: true
            });
         });

        this.closeAllControllerListener = emitter.addListener('closeAllController', () => {
            this.setState({
                open: false
            });
        });

        this.updatePointListener = emitter.addListener('setPoint', (feature, styleCode, zoom) => {
            var [lng, lat] = feature.geometry.coordinates;
            var previewMapUrl = `https://api.mapbox.com/styles/v1/${styleCode}/static/pin-s+f00(${lng},${lat})/${lng},${lat},${zoom},0,1/250x155@2x?access_token=${ACCESS_TOKEN}`;

            this.setState({
                addPointUnwrap: true,
                previewMapUrl: previewMapUrl,
                geometry: feature,
                previewCoordinate: {
                    lng: parseFloat(lng).toFixed(3),
                    lat: parseFloat(lat).toFixed(3)
                }
            });
        });


    
        this.moveURListener = emitter.addListener('moveURL', () => {
            this.moveURL();
        });
    }

    
    setIc(e){
        this.setState({
            Ic:e
        })
    }
    setIh(e){
        this.setState({
            Ih:e
        })
    }
    setIg(e){
        this.setState({
            Ig:e
        })
    }
    setIo(e){
        this.setState({
            Io:e
        })
    }
    setIoType(e){
        this.setState({
            IoType:e
        })
    }
    setIf(e){
        this.setState({
            If:e
        })
    }

    moveURL = () => {
        var url = this.state.url
        this.setState({ movedURL: url });
        console.log(this.state.movedURL)

    }
    processTemperatureData = (data) => {
        const trace = {
            type: 'scatter', 
            mode: 'lines',
            x: data.map(item => new Date(item.sampling_date)),
            y: data.map(item => item.measurement_value),
            name: 'Temperatura del Aire HC',
        };

        this.setState(({
            temperatureData: [trace],
            loading: false // Mantiene el estado de carga si hay más datos por cargar
        }));
    }

    processPrecipitationData = (data) => {
        const trace = {
            type: 'scatter',
            mode: 'lines',
            x: data.map(item => new Date(item.sampling_date)),
            y: data.map(item => item.measurement_value),
            name: 'Precipitación'
        };

        this.setState({ precipitationData: [trace], loading: false });
    }


    componentWillUnmount() {
        // Remove event listeners
        emitter.removeListener(this.openSocControllerListener);
        emitter.removeListener(this.closeAllControllerListener);
        emitter.removeListener(this.addPointListener);
        emitter.removeListener(this.updatePointListener);
        emitter.removeListener(this.moveURListener);


        // Destory Materialbox
        //                         {loading ? <p>Cargando datos...</p> : <Plot data={traces} layout={layout} />}

        var elems = document.querySelectorAll('.materialboxed');
        elems.map(elem => elem.destory());
    }

    render() {        
        // Mostrar métricas si existen en el último layer recibido
        let metricsTable = null;
        if (this.state.url && this.state.url.metrics && Object.keys(this.state.url.metrics).length > 0) {
            const metrics = this.state.url.metrics;
            if (!metrics.error) {
                metricsTable = (
                    <div style={{ marginBottom: 16, textAlign: 'center' }}>
                        <Typography variant="subtitle1" style={{ fontWeight: 'bold', marginBottom: 4 }}>
                            Indicadores de desempeño
                        </Typography>
                        <table style={{ margin: '0 auto', borderCollapse: 'collapse', minWidth: 220 }}>
                            <thead>
                                <tr style={{ background: '#f3e5f5' }}>
                                    <th style={{ padding: '4px 12px', border: '1px solid #ccc' }}>Índice</th>
                                    <th style={{ padding: '4px 12px', border: '1px solid #ccc' }}>Valor</th>
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(metrics).map(([key, value]) => (
                                    <tr key={key}>
                                        <td style={{ padding: '4px 12px', border: '1px solid #ccc' }}>{key}</td>
                                        <td style={{ padding: '4px 12px', border: '1px solid #ccc' }}>{typeof value === 'number' ? value.toFixed(4) : value}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                );
            } else {
                metricsTable = (
                    <div style={{ marginBottom: 16, textAlign: 'center', color: 'red' }}>
                        <Typography variant="subtitle2">{metrics.error}</Typography>
                    </div>
                );
            }
        }
        return (
            <MuiThemeProvider theme={theme}>
                <Slide direction="left" in={this.state.open}>
                    <Card style={styles.root}>
                        {/* Card header */}
                        <CardContent style={styles.header}>
                        <Typography gutterBottom style={{ fontFamily: 'Lato, Arial, sans-serif', color:'white', fontWeight:'3' }} variant="h5" component="h2">Soil Organic Carbon Predictor</Typography>
                            <Typography variant="body2" color="textSecondary">Upload your shape and map soil values</Typography>
			</CardContent>
        <CardContent style={styles.content}>
            {metricsTable}
            <ControlledAccordions onSubmit={this.handleDataSubmit}/>
            <IconButton style={styles.closeBtn} aria-label="Close" onClick={this.handleCloseClick}>
                                <Icon fontSize="inherit">chevron_right</Icon>
                            </IconButton>
                        </CardContent>
                    </Card>
                </Slide>
            </MuiThemeProvider >
        );
    }
}

export default SocController;